module.exports = __webpack_public_path__ + "static/media/rpfpc_youth_football_grant_2016_application.1.a8190f7f.pdf";